import api from '../utils/API';
import type {
  DeleteFaixaRequest,
  EventoDeAuditoria,
  FaixaDePreco,
  FaixaDePrecoRequest,
  SimularPrecoRequest,
  SimularPrecoResponse,
} from '../@types/IPA/PrecoPsicologico';

const BASE = `${process.env.REACT_APP_IPA_URL}/preco-psicologico`;

export const PrecoPsicologicoService = {
  async listarFaixas(): Promise<FaixaDePreco[]> {
    const resp = await api({ url: `${BASE}/faixas`, method: 'GET', expectToken: true });
    return resp.data;
  },

  async criarFaixa(data: FaixaDePrecoRequest): Promise<FaixaDePreco> {
    const resp = await api({ url: `${BASE}/faixas`, method: 'POST', data, expectToken: true });
    return resp.data;
  },

  async editarFaixa(id: string, data: FaixaDePrecoRequest): Promise<FaixaDePreco> {
    const resp = await api({ url: `${BASE}/faixas/${id}`, method: 'PUT', data, expectToken: true });
    return resp.data;
  },

  async excluirFaixa(id: string, data: DeleteFaixaRequest): Promise<void> {
    await api({ url: `${BASE}/faixas/${id}`, method: 'DELETE', data, expectToken: true });
  },

  async simularPreco(data: SimularPrecoRequest): Promise<SimularPrecoResponse> {
    const resp = await api({ url: `${BASE}/simular`, method: 'POST', data, expectToken: true });
    return resp.data;
  },

  async listarHistorico(): Promise<EventoDeAuditoria[]> {
    const resp = await api({ url: `${BASE}/historico`, method: 'GET', expectToken: true });
    return resp.data;
  },

  async listarFaixasAtivas(): Promise<FaixaDePreco[]> {
    const resp = await api({ url: `${BASE}/faixas/ativas`, method: 'GET', expectToken: true });
    return resp.data;
  },
};
